import ApiGateway from "../../explorer/services/ApiGateway";
import { OrderOfferService } from "../../explorer/services/OrderOfferService";
import { SalesConditionsDTO } from "../../explorer/types/OrderOffer/SalesConditions";
import { Site } from "../../explorer/types/SpareParts";
import { endpoints } from "../configuration/endpoints";

export class CustomOrderOfferService extends OrderOfferService {

    public getShipToAddress = (brand: string): Promise<Site[]> => {
        return new Promise<Site[]>((resolve, reject) => {
            ApiGateway()
                .get<Site[]>(
                    endpoints.orderoffer.getShipToAddress.replace(
                        "{brand}",
                        brand
                    )
                )
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };

    public getInvoicesAddress = (brand: string): Promise<Site> => {
        return new Promise<Site>((resolve, reject) => {
            ApiGateway()
                .get<Site>(
                    endpoints.orderoffer.getInvoicesAddress.replace(
                        "{brand}",
                        brand
                    )
                )
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };

    public checkOrderOfferReference = (
        brand: string,
        orderoffer: string,
        pon: string
    ): Promise<any> => {
        return new Promise<any>((resolve, reject) => {
              
            ApiGateway()
                .get<any>(
                    endpoints.orderoffer.checkOrderOfferReference
                        .replace("{brand}", brand)
                        .replace("{orderoffer}", orderoffer)
                        .replace("{pon}", encodeURIComponent(pon))
                )
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };

    public salesConditions = (brand: string): Promise<SalesConditionsDTO> => {
        return new Promise<SalesConditionsDTO>((resolve, reject) => {
            ApiGateway()
                .get<SalesConditionsDTO>(endpoints.orderoffer.salesConditions.replace("{brand}", brand))
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };
}
